import Hero from "./hero.jsx";
export default Hero;
